import pakTani from 'assets/icons/Pak-Tani.png'
import AmountInput from 'components/AmountInput'
import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import { Can } from 'context/Acl'
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { AlertCircle, ArrowLeft, Check, Edit2, Trash2 } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Badge,
  Button,
  Card,
  CardBody,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Spinner,
} from 'reactstrap'
import { URL_PIUTANG, URL_UTANG } from 'utils/pathUrl'
import {
  BUSINESS_AR_AP,
  BUSINESS_AR_AP_COMPANY,
  MANAGE,
} from 'utils/subjectActions'
import {
  setIsModalOpenAddAddressBook,
  setSearchAddressBook,
} from '../address-book/addressBookSlice'
import InputAddressBook from '../address-book/InputAddressBook'
import ModalAddContact from '../address-book/ModalAddContact'
import {
  usePostReceivableMutation,
  usePostReceivablePersonalMutation,
} from '../receivable-notes/receivableNotesApiSlice'
import {
  toggleBannerReceivable,
  toggleModalCategoryReceivable,
  toggleModalDeleteReceivable,
} from '../receivable-notes/receivableNotesSlice'
import ModalCategory from './ModalCategory'
import ModalDelete from './ModalDelete'
import {
  useGetCategoriesPersonalQuery,
  useGetCategoriesQuery,
  useLazyCheckPhoneNumberPayableQuery,
  usePostPayableMutation,
  usePostPayablePersonalMutation,
} from './payableNotesApiSlice'
import {
  toggleBanner,
  toggleModalCategory,
  toggleModalDelete,
} from './payableNotesSlice'
import PMBProjectSelections from 'components/PMBProjectSelections'
import ProfilePic from 'components/PMBProfilePic'
import { useAbilityAccess } from 'hooks/useAbilityAccess'

const FormPayableNotes = () => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { state } = useLocation()
  const [payload, setPayload] = useState()
  const [amount, setAmount] = useState(null)
  const [errMsg, setErrMsg] = useState('')
  const [errMsgPhoneNumber, setErrMsgPhoneNumber] = useState('')
  const [category, setCategory] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [dataUser, setDataUser] = useState(null)
  const [project, setProject] = useState(null)
  const addressBookRef = useRef(null)

  const [savedContacts, setSavedContacts] = useState([])

  const { ownerData, profile } = useSelector((s) => s.dashboard)
  const { isOpenModalCategory, isOpenModalDelete, isOpenModalContacts, type } =
    useSelector((state) => state.payableNotes)
  const {
    isOpenModalCategory: isOpenModalCategoryReceivable,
    isOpenModalDelete: isOpenModalDeleteReceivable,
    isOpenModalContacts: isOpenModalContactsReceivable,
  } = useSelector((state) => state.receivableNotes)
  const { isModalOpenAddAddressBook } = useSelector((e) => e.addressBook)

  const userId = type === 'personal' ? profile?.userId : ownerData?.userId

  const { data: dataCategoryCompany, isLoading: isLoadingCompany } =
    useGetCategoriesQuery(
      {
        type: state?.isReceivable ? 'receivable' : 'payable',
        active: 1,
        userId: userId,
      },
      { skip: !userId || type === 'personal' },
    )

  const { data: dataCategoryPersonal, isLoading: isLoadingPersonal } =
    useGetCategoriesPersonalQuery(
      {
        type: state?.isReceivable ? 'receivable' : 'payable',
        active: 1,
        userId: userId,
      },
      { skip: !userId || type === 'company' },
    )

  const dataCategory =
    type === 'personal' ? dataCategoryPersonal : dataCategoryCompany
  const isLoading = type === 'personal' ? isLoadingPersonal : isLoadingCompany

  const [postPayableCompany, resultPayableCompany] = usePostPayableMutation()
  const [postPayablePersonal, resultPayablePersonal] =
    usePostPayablePersonalMutation()
  const [postReceivableCompany, resultReceivableCompany] =
    usePostReceivableMutation()
  const [postReceivablePersonal, resultReceivablePersonal] =
    usePostReceivablePersonalMutation()

  const postPayable =
    type === 'personal' ? postPayablePersonal : postPayableCompany
  const postReceivable =
    type === 'personal' ? postReceivablePersonal : postReceivableCompany

  const result =
    type === 'personal' ? resultPayablePersonal : resultPayableCompany
  const resultReceivable =
    type === 'personal' ? resultReceivablePersonal : resultReceivableCompany

  const [checkPhoneNumber, res] = useLazyCheckPhoneNumberPayableQuery()

  const hasPersonalAbilityMANAGE = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_AR_AP,
  })
  const hasCompanyAbilityMANAGE = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_AR_AP_COMPANY,
  })

  const handleEditCategory = () => {
    if (!isEdit) {
      setIsEdit(true)
      setPayload((prev) => {
        return {
          ...prev,
          category: null,
        }
      })
    } else {
      setIsEdit(false)
    }
  }

  const handleCheckPhoneNumber = async (phoneOrEmail) => {
    try {
      if (phoneOrEmail) {
        const res = await checkPhoneNumber({
          search: phoneOrEmail,
          type: 'ARAP',
        })
        if (res?.error || res?.isError) {
          setErrMsg(res?.error?.data?.message)
          setDataUser(null)
        } else if (res?.data?.status === 'UNREGISTERED') {
          setDataUser(null)
          setErrMsgPhoneNumber(
            'Nomor tidak terdaftar. Kami hanya akan mencatat nama yang dimasukkan.',
          )
        } else {
          setErrMsg('')
          setErrMsgPhoneNumber('')
          setDataUser(res?.data)
          setPayload((prev) => {
            return {
              ...prev,
              name: res?.data?.fullName,
            }
          })
        }
      }
    } catch {
      // Error fetching data
    }
  }

  const handleSubmit = async () => {
    try {
      let body = {}
      if (state?.isReceivable) {
        body = {
          amount: Number(
            amount?.replace?.(/\./g, '')?.replace?.(/,/g, '.')?.slice?.(0, 15),
          ),
          notes: payload?.notes,
          categoryId: payload?.category?.id,
          payerName: payload?.name ?? payload?.relationName,
          ...((dataUser?.relationUserId ||
            dataUser?.relationEmailUserId ||
            dataUser?.status === 'REGISTERED') && {
            payerUserId:
              dataUser?.relationUserId ??
              dataUser?.relationEmailUserId ??
              dataUser?.userId,
            payerPhoneNumber:
              payload?.phoneNumber ?? payload?.relationPhoneNumber,
          }),
          saveRelation: payload?.saveRelation,
          ...(project ? { projectId: project?.value ?? project?.id } : {}),
        }
      } else {
        body = {
          payerUserId: userId,
          amount: Number(
            amount?.replace?.(/\./g, '')?.replace?.(/,/g, '.')?.slice?.(0, 15),
          ),
          notes: payload?.notes,
          accountReceiveName: payload?.name ?? payload?.relationName,
          ...((dataUser?.relationUserId ||
            dataUser?.relationEmailUserId ||
            dataUser?.status === 'REGISTERED') && {
            userId:
              dataUser?.relationUserId ??
              dataUser?.relationEmailUserId ??
              dataUser?.userId,
            accountReceivePhoneNumber:
              payload?.phoneNumber ?? payload?.relationPhoneNumber,
          }),
          categoryId: payload?.category?.id,
          saveRelation: payload?.saveRelation,
          ...(project ? { projectId: project?.value ?? project?.id } : {}),
        }
      }
      const resp = state?.isReceivable
        ? await postReceivable(body).unwrap()
        : await postPayable(body).unwrap()
      if (!resp?.data?.error) {
        // SAVED SELECTED ADDRESS BOOK TO LOCALSTORAGE
        const storageKey = `payableAddressBook-${userId}`
        const storedData = JSON.parse(localStorage.getItem(storageKey) || '[]')

        const contactToStore = {
          relationName: payload.relationName,
          relationPhoneNumber: payload.relationPhoneNumber,
          relationEmail: payload.relationEmail,
        }

        const filteredData = storedData.filter(
          (item) => item.relationName !== payload.relationName,
        )

        filteredData.unshift(contactToStore)

        const trimmedData = filteredData.slice(0, 3)

        localStorage.setItem(storageKey, JSON.stringify(trimmedData))
        // END SAVED SELECTED ADDRESS BOOK TO LOCALSTORAGE

        navigate(state?.isReceivable ? URL_PIUTANG : URL_UTANG)
        dispatch(
          state?.isReceivable
            ? enqueueSnackbar('Piutang baru berhasil dicatat.', {
              variant: 'success',
            })
            : enqueueSnackbar('Utang baru berhasil dicatat.', {
              variant: 'success',
            }),
        )

        dispatch(
          state?.isReceivable ? toggleBannerReceivable() : toggleBanner(),
        )
      } else {
        throw resp
      }
    } catch (error) {
      setErrMsg(error?.data?.message ?? error?.message)
    }
  }

  const handleSelectedContact = (contact) => {
    handleCheckPhoneNumber(
      contact?.relationPhoneNumber ?? contact?.relationEmail,
    )

    if (Object.keys(contact).length !== 0) {
      setDataUser(contact)
      setPayload((prev) => ({
        ...prev,
        ...contact,
      }))
    } else {
      setErrMsg('')
      setErrMsgPhoneNumber('')
      setDataUser(null)
      setPayload((prev) => ({
        ...(prev?.category ? { category: prev.category } : {}),
      }))
    }
  }

  useEffect(() => {
    setErrMsg('')
  }, [amount])

  const toggleOpenCloseAddContact = () => {
    dispatch(setIsModalOpenAddAddressBook(!isModalOpenAddAddressBook))
  }

  // HANDLE AUTO FOCUS
  useEffect(() => {
    setTimeout(() => {
      addressBookRef.current?.focus()
    }, 0)
  }, [])

  // HANDLE ADDRESS BOOK FROM LOCALSTORAGE
  useEffect(() => {
    const storageKey = `payableAddressBook-${userId}`
    const savedData = JSON.parse(localStorage.getItem(storageKey) || '[]')
    setSavedContacts(savedData)
  }, [userId])

  return (
    <Container className="custom-container d-flex flex-column gap-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs
          breadCrumbActive={
            state?.isReceivable ? 'Catat Piutang' : 'Catat Utang'
          }
          breadCrumbParent={state?.isReceivable ? 'Piutang' : 'Utang'}
          breadCrumbParentLink={state?.isReceivable ? URL_PIUTANG : URL_UTANG}
        />
      </div>
      <ModalCategory
        isReceivable={state?.isReceivable}
        isOpen={
          state?.isReceivable
            ? isOpenModalCategoryReceivable
            : isOpenModalCategory
        }
        toggle={() =>
          dispatch(
            state?.isReceivable
              ? toggleModalCategoryReceivable()
              : toggleModalCategory(),
          )
        }
        row={category}
      />
      <ModalAddContact
        isOpen={isModalOpenAddAddressBook}
        toggle={toggleOpenCloseAddContact}
        isOutsideAddressBook
      />
      <ModalDelete
        isReceivable={state?.isReceivable}
        isOpen={
          state?.isReceivable ? isOpenModalDeleteReceivable : isOpenModalDelete
        }
        toggle={() =>
          dispatch(
            state?.isReceivable
              ? toggleModalDeleteReceivable()
              : toggleModalDelete(),
          )
        }
        row={category}
      />
      <Card className="border-0 shadow-sm">
        <CardBody>
          <h5 className="fw-semibold">
            <ArrowLeft
              style={{ cursor: 'pointer' }}
              onClick={() =>
                navigate(state?.isReceivable ? URL_PIUTANG : URL_UTANG)
              }
            />{' '}
            Catat {state?.isReceivable ? 'Piutang' : 'Utang'}
          </h5>

          <Label className="fw-500 d-flex justify-content-between mt-4">
            <span>
              Kategori<span className="text-danger">*</span>
            </span>

            {(hasPersonalAbilityMANAGE || hasCompanyAbilityMANAGE) && (
              <span
                onClick={() => handleEditCategory()}
                className={isEdit ? 'text-success' : 'text-primary'}
                style={{ cursor: 'pointer' }}
              >
                {isEdit ? 'Selesai' : 'Atur Kategori'}
              </span>
            )}
          </Label>
          {isLoading ? (
            <div className="flex-centered">
              {' '}
              <Spinner />{' '}
            </div>
          ) : (
            dataCategory?.map((e, i) => {
              return (
                <div
                  key={i}
                  className="py-2"
                  onClick={() => {
                    if (!isEdit) {
                      setPayload((prev) => {
                        return {
                          ...prev,
                          category: e,
                        }
                      })
                    }
                  }}
                >
                  <div
                    style={{
                      backgroundColor:
                        payload?.category?.id === e?.id ? '#ECFAFF' : '',
                      cursor: 'pointer',
                    }}
                    className={`border rounded p-3 d-flex ${isEdit ? 'justify-content-between' : 'gap-2'} ${payload?.category?.id === e?.id ? 'border-primary' : ''}`}
                  >
                    {isEdit ? (
                      <></>
                    ) : (
                      <Input
                        type="radio"
                        id="category"
                        name="category"
                        value={payload?.category?.id ?? ''}
                        onChange={() => {
                          if (!isEdit) {
                            setPayload((prev) => {
                              return {
                                ...prev,
                                category: e,
                              }
                            })
                          }
                        }}
                        checked={payload?.category?.id === e?.id}
                        autoComplete="off"
                      />
                    )}
                    {e?.label}
                    {isEdit ? (
                      <div className="d-flex gap-3">
                        <Edit2
                          onClick={() => {
                            setCategory(e)
                            dispatch(
                              state?.isReceivable
                                ? toggleModalCategoryReceivable()
                                : toggleModalCategory(),
                            )
                          }}
                          style={{ cursor: 'pointer' }}
                          size={16}
                        />
                        <Trash2
                          onClick={() => {
                            setCategory(e)
                            dispatch(
                              state?.isReceivable
                                ? toggleModalDeleteReceivable()
                                : toggleModalDelete(),
                            )
                          }}
                          style={{ cursor: 'pointer' }}
                          size={16}
                          className="text-danger"
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )
            })
          )}

          {isEdit ? (
            <>
              <hr></hr>
              <CustomButton
                onClick={() => {
                  setCategory(null)
                  dispatch(
                    state?.isReceivable
                      ? toggleModalCategoryReceivable()
                      : toggleModalCategory(),
                  )
                }}
                outline
                color="primary"
              >
                + Tambah Kategori
              </CustomButton>
            </>
          ) : (
            <></>
          )}
        </CardBody>
      </Card>
      <Card className="border-0 shadow-sm mb-3">
        <CardBody>
          <div className="mb-3">
            <InputAddressBook
              title={`${state?.isReceivable ? 'Piutang' : 'Utang'} kepada`}
              onSelectContact={handleSelectedContact}
              fieldName="relationName"
              editValue={
                payload?.relationPhoneNumber
                  ? `${payload?.relationName} (${payload?.relationPhoneNumber})`
                  : payload?.relationEmail
                    ? `${payload?.relationName} (${payload?.relationEmail})`
                    : payload?.relationName
              }
              onClickAdd={(localSearch) =>
                dispatch(setSearchAddressBook(localSearch))
              }
              innerRef={addressBookRef}
              isRequired
              useCombinedContacts
            />
          </div>

          {savedContacts?.length > 0 && !payload?.relationName && (
            <div
              className="d-flex gap-2 my-4"
              style={{ minWidth: '100%', overflow: 'auto' }}
            >
              {savedContacts.map((contact, i) => {
                const displayName = contact.relationPhoneNumber
                  ? `${contact.relationName} (${contact.relationPhoneNumber})`
                  : `${contact.relationName}${contact.relationEmail ? ` (${contact.relationEmail})` : ''}`

                return (
                  <div
                    key={i}
                    onClick={() => {
                      const displayName = contact.relationPhoneNumber
                        ? `${contact.relationName} (${contact.relationPhoneNumber})`
                        : `${contact.relationName}${contact.relationEmail ? ` (${contact.relationEmail})` : ''}`

                      setPayload((prev) => ({
                        ...prev,
                        relationName: contact.relationName,
                        relationPhoneNumber: contact.relationPhoneNumber,
                        relationEmail: contact.relationEmail,
                      }))

                      dispatch(setSearchAddressBook(displayName))

                      handleSelectedContact({
                        relationName: contact.relationName,
                        relationPhoneNumber: contact.relationPhoneNumber,
                        relationEmail: contact.relationEmail,
                      })

                      if (
                        contact.relationPhoneNumber ||
                        contact.relationEmail
                      ) {
                        handleCheckPhoneNumber(
                          contact.relationPhoneNumber || contact.relationEmail,
                        )
                      }
                    }}
                    className="rounded p-3 bg-gray-50 hover-100 pointer"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span>{displayName}</span>
                    </div>
                  </div>
                )
              })}
            </div>
          )}

          {dataUser && (
            <FormGroup>
              <div className="flex-centered justify-content-between border p-2 rounded bg-success-25 border-success">
                <div className="flex-centered gap-2">
                  <ProfilePic
                    imgSrc={dataUser?.profileImg}
                    altText={dataUser?.fullName ?? dataUser?.relationName}
                    name={dataUser?.fullName ?? dataUser?.relationName}
                    avatarSeed={
                      dataUser?.userId ??
                      dataUser?.relationUserId ??
                      dataUser?.relationEmailUserId
                    }
                    width={36}
                    height={35}
                  />
                  <span className="text-sm fw-semibold">
                    {dataUser?.fullName ?? dataUser?.relationName}
                  </span>
                </div>
                <>
                  <Check className="text-success" />
                </>
                <Badge size="sm" disabled className={'badge-warning'}></Badge>
              </div>
            </FormGroup>
          )}
          {errMsgPhoneNumber && (
            <FormGroup>
              <small className="text-warning-700 fw-500">
                <AlertCircle size={15} /> {errMsgPhoneNumber}
              </small>
            </FormGroup>
          )}

          {type !== 'personal' && (
            <FormGroup>
              <Label>Project (opsional)</Label>
              <PMBProjectSelections
                value={project}
                onChange={(e) => {
                  setProject(e)
                }}
                placeholder="Pilih project"
              />
            </FormGroup>
          )}

          <FormGroup>
            <Label>
              Jumlah {state?.isReceivable ? 'piutang' : 'utang'}
              <span className="text-danger">*</span>
            </Label>

            <InputGroup>
              <InputGroupText className="bg-transparent">Rp</InputGroupText>
              <AmountInput
                cb={(res) => {
                  setAmount(res)
                }}
                placeholder="0"
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label>Catatan</Label>
            <Input
              type="textarea"
              style={{ minHeight: '128px' }}
              name="notes"
              onChange={(e) => {
                setPayload((prev) => ({
                  ...prev,
                  [e.target.name]: e.target?.value,
                }))
              }}
              value={payload?.notes}
              placeholder="Tambah catatan jika ada..."
            />
          </FormGroup>
          {errMsg && (
            <FormGroup>
              <small className="text-danger">
                <AlertCircle size={15} /> {errMsg}
              </small>
            </FormGroup>
          )}
          <div className="d-flex gap-3">
            <Button
              onClick={() =>
                navigate(state?.isReceivable ? URL_PIUTANG : URL_UTANG)
              }
              outline
              className="btn-cancel"
              block
            >
              Batal
            </Button>
            {(hasPersonalAbilityMANAGE || hasCompanyAbilityMANAGE) && (
              <CustomButton
                onClick={() => handleSubmit()}
                disabled={
                  !payload ||
                  !payload?.category ||
                  !amount ||
                  result?.isLoading ||
                  resultReceivable?.isLoading ||
                  !(payload?.name || payload?.relationName) ||
                  res?.isLoading ||
                  res?.status === 'pending'
                }
                block
                color="primary"
              >
                Simpan
              </CustomButton>
            )}
          </div>
        </CardBody>
      </Card>
    </Container>
  )
}

export default FormPayableNotes
